import { FaWhatsapp, FaArrowRight } from "react-icons/fa6";
import Reveal from "@/components/site/Reveal";
import { WHATSAPP_LINK } from "@/data/content";

const CTA = () => {
  const scrollToContact = () => {
    if (window.lenis) {
      window.lenis.scrollTo("#contact", { duration: 1.0 });
    } else {
      document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section data-testid="cta-section" className="bg-white px-4 py-12 md:px-8">
      <div className="noise relative mx-auto max-w-[1300px] overflow-hidden rounded-[36px] bg-green-primary px-6 py-20 text-center md:px-10 md:py-28 shadow-luxe border border-gold-soft">
        {/* background glow */}
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[360px] w-[560px] -translate-x-1/2 -translate-y-1/2 animate-floatY rounded-full bg-gold-soft/20 blur-[80px] will-change-transform" />

        <div className="relative z-10">
          <Reveal>
            <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-gold-primary">
              Accelerate Your Hiring Pipeline
            </p>
            <h2 className="mx-auto max-w-4xl font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-white sm:text-5xl md:text-7xl">
              Ready to Build Your
              <span className="block italic text-gradient-gold">Dream Team?</span>
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/85 md:text-lg font-normal">
              Partner with PLACE8 to hire exceptional professionals across executive search,
              IT & non-IT domains, healthcare, BFSI, and mass recruitment.
            </p>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <button
                data-testid="cta-hire-talent"
                onClick={scrollToContact}
                className="btn-gold group inline-flex items-center gap-3 rounded-full px-9 py-4 text-xs md:text-sm font-bold uppercase tracking-[0.12em] text-white transition-transform duration-300 hover:-translate-y-1 shadow-luxe"
              >
                Hire Talent
                <FaArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>

              <a
                data-testid="cta-book-consultation"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary-green group inline-flex items-center gap-3 rounded-full px-9 py-4 text-xs md:text-sm font-bold uppercase tracking-[0.12em] shadow-soft transition-all duration-300 hover:-translate-y-0.5"
              >
                <FaWhatsapp className="text-lg text-gold-primary group-hover:text-white" />
                Book Consultation
                <FaArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default CTA;
